import { getVariant } from '@chessbut/engine';
import { type Leaderboard, variantDay } from '@chessbut/shared';
import { useEffect, useState } from 'react';
import { LeaderboardTable } from '../components/LeaderboardTable.tsx';
import { variantStyle } from '../components/Brand.tsx';
import { RulesList } from '../components/Rules.tsx';
import { api } from '../lib/api.ts';
import { canOpenVariant, useSession } from '../lib/session.ts';
import { ChallengeCard, VariantHero, useChallenge } from './Home.tsx';
import { NotFound } from './Static.tsx';

export function VariantPage({ id }: { id: string }) {
  const { campaign, me } = useSession();
  const variant = getVariant(id);
  const challenge = useChallenge();
  const [board, setBoard] = useState<Leaderboard | null>(null);
  useEffect(() => {
    api<Leaderboard>(`/api/leaderboard?kind=rating&key=${encodeURIComponent(id)}`)
      .then(setBoard)
      .catch(() => {});
  }, [id, me?.id]);
  if (!campaign) return <div className="page loading"><span className="spinner big" /></div>;
  const released = campaign.released.find((r) => r.variant === id);
  if (!variant || !released || !canOpenVariant({ campaign, me }, id)) {
    const day = variant ? variantDay(variant.id) : null;
    return <NotFound title={day ? `Day ${day} isn't out yet` : undefined} text={day ? 'No peeking. Check back when it drops.' : undefined} />;
  }
  const featured = campaign.featured?.variant === id;
  const mine = me?.ratings[id];
  return (
    <div className="page home" style={variantStyle(variant)}>
      <VariantHero variant={variant} campaign={campaign} featured={featured} />
      {featured && <ChallengeCard info={challenge} />}
      <section className="group">
        <h2 className="section-title">Rules</h2>
        <RulesList variant={variant} />
      </section>
      <section className="group">
        <div className="spread">
          <h2 className="section-title">Top {variant.info.name} players</h2>
          {mine && (
            <span className="muted small">
              You: <b className="num">{mine.rating}</b>
              {mine.provisional ? '?' : ''}
            </span>
          )}
        </div>
        <LeaderboardTable
          rows={board?.rows.slice(0, 10) ?? []}
          me={board?.me ?? null}
          unit=""
          meId={me?.id ?? null}
          empty="No ranked players yet: 5 rated games gets you on this board."
        />
      </section>
    </div>
  );
}
